module.exports = __webpack_public_path__ + "static/media/1.e4451443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9017/1.jpg
// module id = 865
// module chunks = 0